import { Injectable } from "@angular/core";
import { HttpVerbs, NGHttpService } from "./commons/ng-http.service";
import { AuthService } from "./commons/auth.service";
import { MovimentoDTO } from "../models/movimentiDTO";

import { RataDTO } from "../models/rataDTO";

@Injectable({
  providedIn: 'root'
})
export class MovimentiService {

  private endPoint: string = '/wallet';


  constructor(
    private readonly ngHttpService: NGHttpService,
    private readonly authService: AuthService,
  ) { }

  async update(params: any={}): Promise<any> {
    return await this.ngHttpService.execute(HttpVerbs.PUT, `${this.endPoint}/movimento`, params,  this.mapToModel, () => this.authService.getToken());
  }
  async listMovimentazioni(params: any = {}): Promise<any> {
    return await this.ngHttpService.execute(HttpVerbs.POST, `${this.endPoint}/listMovimentazioni`, params, null, () => this.authService.getToken());
  }


  async listContoOro(params: any = {}): Promise<any> {
    return await this.ngHttpService.execute(HttpVerbs.POST, `${this.endPoint}/listContoOro`, params, null, () => this.authService.getToken());
  }



  async getPAM(params: any = {}): Promise<any> {
    return await this.ngHttpService.execute(HttpVerbs.POST, `${this.endPoint}/listRate`, params, this.rateToModel, () => this.authService.getToken());
  }
  async getHistory(params: any = {}): Promise<any> {
    return await this.ngHttpService.execute(HttpVerbs.POST, `${this.endPoint}/listHistory`, params, null, () => this.authService.getToken());
  }
  async saveRata(params: any = {}): Promise<any> {
    return await this.ngHttpService.execute(HttpVerbs.POST, `${this.endPoint}/saveRate`, params, null, () => this.authService.getToken());
  }
 /* async list(params: any = {}): Promise<Array<User>> {
    return await this.ngHttpService.execute(HttpVerbs.GET, `${this.endPoint}`, params, this.mapToModel, () => this.authService.getToken());
  }

  async get(id: any, params: any={}): Promise<User> {
    return await this.ngHttpService.execute(HttpVerbs.GET, `${this.endPoint}/${id}`, params, this.mapToModel, () => this.authService.getToken());
  }

  async save(model: User): Promise<any> {
    return await this.ngHttpService.execute(HttpVerbs.POST, this.endPoint, model.toObject(true), this.mapToModel, () => this.authService.getToken());
  }

  async createcredit(body: any) {
    return await this.ngHttpService.execute(HttpVerbs.POST, `${this.endPoint}/createcredit`, body, null, () => this.authService.getToken());
  }

  async delete(id: any): Promise<boolean> {
    return await this.ngHttpService.execute(HttpVerbs.DELETE, `${this.endPoint}/${id}`, null, null, () => this.authService.getToken());
  }

  async recovery(email: string): Promise<any> {
    return await this.ngHttpService.execute(HttpVerbs.GET, `${this.endPoint}/recoveryPassword/${email}`, null, null);
  }
*/

  /*=======================================================================*/
  /*mapToModel(item: any) {
    let model = User.fromObject(item, new User());
    return model;
  }*/
    mapToModel(item: any) {
      let model = MovimentoDTO.fromObject(item, new MovimentoDTO());
      return model;
    }
    rateToModel(resp:any){
      if(resp.data.length>0){
        let list:RataDTO[] = [];
        resp.data.forEach((item:any)=>{
          let r = new RataDTO();
          r.id =item.id;
          r.data = new Date(item.data);
          r.gestione = parseFloat(item.gestione);
          r.grAcquistati = parseFloat(item.grAcquistati);
          r.importoDaPagare = parseFloat(item.importoDaPagare);
          r.importoPagato = parseFloat(item.importoPagato);
          r.isLast = item.isLast;
          r.pagato = item.pagato;
          r.paoId = item.paoId;
          r.urlfattura=item.urlfattura;
          r.progressivo = parseInt(item.progressivo);
          r.secondoFix = parseFloat(item.secondoFix);
          r.numerodeposito = item.numerodeposito;
          r.numeroFattura= item.numeroFattura;
          r.updated_at = item.updated_at;
          list.push(r)
          
        }); 
        resp.data = list;
        return resp;
      } 
    }
}
